import { Body, Button, Card, CardSection } from '@growtherapy/sprout-ui';

import {
  MINOR_ACKNOWLEDGEMENT_CANCEL_BUTTON_TEXT,
  MINOR_CONSENT_ACKNOWLEDGEMENT_CONFIRM_BUTTON_TEXT,
  MINOR_CONSENT_ACKNOWLEDGEMENT_TEXT,
  MINOR_TRANSCRIPTION_ACKNOWLEDGEMENT_CONFIRM_BUTTON_TEXT,
  MINOR_TRANSCRIPTION_ACKNOWLEDGEMENT_TEXT,
} from './constants';

export function MinorTranscriptionAcknowledgement({
  hasConsent,
  onCancel,
  onConfirm,
}: {
  hasConsent: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <Card className='w-[88vw] xs:max-w-[25rem] p-0 sm:p-0'>
      <CardSection className='p-6'>
        <Body.Small className='text-neutral-800 text-left arc:text-text-default'>
          {hasConsent ? MINOR_TRANSCRIPTION_ACKNOWLEDGEMENT_TEXT : MINOR_CONSENT_ACKNOWLEDGEMENT_TEXT}
        </Body.Small>
      </CardSection>
      <CardSection className='px-6 last:pb-6 flex justify-center'>
        <Button onClick={onCancel} use='secondary'>
          {MINOR_ACKNOWLEDGEMENT_CANCEL_BUTTON_TEXT}
        </Button>
        <Button onClick={onConfirm} use='primary'>
          {hasConsent
            ? MINOR_TRANSCRIPTION_ACKNOWLEDGEMENT_CONFIRM_BUTTON_TEXT
            : MINOR_CONSENT_ACKNOWLEDGEMENT_CONFIRM_BUTTON_TEXT}
        </Button>
      </CardSection>
    </Card>
  );
}
